export default "__VITE_ASSET__CsDvzSuO__"